"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormContext = exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _helpers = require("../utils/helpers");

var _FormStyled = require("./Form-styled");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var FormContext = (0, _react.createContext)({
  noValidation: false
});
exports.FormContext = FormContext;
FormContext.displayName = 'FormContext';

var Form = function Form(_ref) {
  var children = _ref.children,
      noValidation = _ref.noValidation,
      other = _objectWithoutProperties(_ref, ["children", "noValidation"]);

  var formContext = (0, _helpers.useContextState)({
    noValidation: noValidation
  });
  return _react.default.createElement(FormContext.Provider, {
    value: formContext
  }, _react.default.createElement(_FormStyled.StyledForm, other, children));
};

exports.default = Form;
Form.propTypes = {
  /** The content of the component. */
  children: _propTypes.default.node,

  /** Display prop to make Forms align items horizontally instead of vertically. */
  horizontal: _propTypes.default.bool,

  /** If the FormControl doesn't need validation, you can set this to true to tighten up the bottom margin. */
  noValidation: _propTypes.default.bool
};
Form.defaultProps = {};
Form.displayName = 'Form';